import * as actionTypes from '../constants/actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.HOME_PAGE_LOADED:
    case actionTypes.OUTER_BORDERS_LOADED:
      return {
        ...state
      };
    case actionTypes.HOME_PAGE_UNLOADED:      
    case actionTypes.OUTER_BORDERS_UNLOADED:  
      return {};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/home.js